import React from 'react';
import Login from './Login';

export default function Register() {
  return <Login initialTenantFormOpen />;
}
